const dashboard_card = {
    computed: {
        record () {
            if(!this.card) return null
            return this.card.record
        }
    },
    props: {
        card: {
            type: Object,
            required: true
        }
    },
    data () {
        return {
            loading: true
        }
    }
}

export default dashboard_card
